module.exports = __webpack_public_path__ + "static/img/2929_phase_function_Paper_PointsHejduk_Prediction.9a4e9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2929_phase_function_Paper_PointsHejduk_Prediction.png
// module id = o1LC
// module chunks = 0